import client from './client';

const BASE_URL = '/api/v1/manufacturing/auto-plans';

/**
 * 발주 단계 생산계획 미리보기.
 *
 * 아무것도 저장하지 않는다. 원가산출 내역을 생산계획 후보로 바꿔 돌려줄 뿐이다.
 * available 이 false 면 띄우지 않는다 — 생산 기능을 안 쓰거나, 이미 계획이 있거나,
 * 원가 내역이 없는 경우다.
 */
export const previewAutoPlans = (prjUuid) =>
  client.get(`${BASE_URL}/preview/${prjUuid}`);

/**
 * 미리보기에서 확정한 것들을 한 번에 만든다.
 * 하나라도 걸리면 전부 되돌아온다.
 */
export const createAutoPlans = (requests) => client.post(BASE_URL, requests);
